import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Sku } from '../../domain/models/Sku';
import { Form } from 'react-bootstrap';
import { ImgPlaceholder } from '../ImgPlaceholder';
import Placeholder from '../../img/icon/paquete.svg';
import { SaleModal, Sku as LibSku, RequestParam as LibRequestParam } from '@movivendor/mv-components';
import { getSkuDetailUseCase, sellUseCase } from '../../di/usecase_module';
import { GetSkuDetailRequestDto } from '../../domain/usecases/sku/GetSkuDetailUseCase';
import { RequestParam } from '../../domain/models/RequestParam';
import logo from '../../assets/img/logo-final.svg';
import { useDispatch } from 'react-redux';
import { SaleActions } from '../../presentation/redux/actions/SaleActions';

const adaptLocalSkuToLib = (localSku: Sku): LibSku => ({
    sku: localSku.sku,
    skuName: localSku.skuName,
    logoPath: localSku.logoPath,
});

const adaptLibParamsToLocal = (libParams: LibRequestParam[]): RequestParam[] => {
    return libParams.map(p => new RequestParam(
        p.name,
        p.value,
        p.description,
        p.isHidden,
        p.subprod || 0
    ));
};


export const SkuList = ({ options, handleSetSku, onOpenSaleModal }: any) => {
    const [optionsFiltered, setOptionsFiltered] = useState(options)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSku, setSelectedSku] = useState<LibSku | undefined>(undefined);
    const [logoUrl, setLogoUrl] = useState<string>(logo);
    const dispatch = useDispatch();

    useEffect(() => {
        setLogoUrl(logo);
    }, []);

    function handleOnChange(value: string) {
        if (value.length === 0) {
            setOptionsFiltered(options);
        } else {
            const filtered = options.filter((s: Sku) => {
                return s.skuName.toUpperCase().includes(value.toUpperCase());
            });
            setOptionsFiltered(filtered);
        }

    }
    const imgPlaceholder = Placeholder;

    const handleSkuShortcutClick = (sku: Sku) => {
        if (onOpenSaleModal) {
            const libSku = adaptLocalSkuToLib(sku);
            onOpenSaleModal(libSku, sku.skuName);
        } else {
            const libSku = adaptLocalSkuToLib(sku);
            setSelectedSku(libSku);
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = (e?: any) => {
        dispatch(SaleActions.reset());
        dispatch(SaleActions.close());
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        setIsModalOpen(false);
    };

    const handleSkuSelect = async (sku: LibSku): Promise<any[]> => {
        try {
            const response = await getSkuDetailUseCase().execute(
                new GetSkuDetailRequestDto(sku.sku)
            );
            return response.elements || [];
        } catch (error) {
            throw error;
        }
    };

    const handleProcessPayment = async (params: LibRequestParam[]): Promise<any> => {
        try {
            const localParams = adaptLibParamsToLocal(params);
            const response = await sellUseCase().execute(localParams);
            return response.elements || [];
        } catch (error) {
            throw error;
        }
    };

    return (
        <>
            <div>
                <h4 className="text-muted text-center">Selecciona una opción</h4>
                {
                    (options?.length ?? 0) > 8 ?
                        <div className="p-4">
                            <Form.Control
                                type="text"
                                placeholder="Buscar..."
                                style={{
                                    'textAlign': 'left',
                                    'fontSize': '18px'
                                }}
                                onChange={(e) => {
                                    handleOnChange(e.target.value)
                                }}
                            />
                        </div> : <></>

                }
                <div className="d-flex flex-wrap justify-content-around ">
                    {optionsFiltered && optionsFiltered.map((item: Sku) => {
                        return (
                            <div key={item.sku} className="skubtn" onClick={() => handleSkuShortcutClick(item)}>
                                <ImgPlaceholder
                                    key={item.sku}
                                    style={{
                                        height: '60px',
                                        width: '60px'
                                    }}
                                    placeholder={imgPlaceholder}
                                    img={item.logoPath} />
                                <div className="justify-content-center text-muted text-center">
                                    <small className="">{item.skuName}</small>
                                </div>
                            </div>)
                    })
                    }
                </div>
            </div>

            {!onOpenSaleModal && (
                <SaleModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    setup={{
                        title: String(selectedSku ? selectedSku.skuName : ''),
                        sku: selectedSku
                    }}
                    onSkuSelect={handleSkuSelect}
                    onProcessPayment={handleProcessPayment}
                    logoUrl={logoUrl}
                    onSendReceipt={async (phone, dni) => {
                    // Lógica para enviar la boleta
                    console.log('Enviando a:', phone, dni);
                    //await api.sendReceipt(phone, dni);
                }}
                />
            )}
        </>
    )
}

SkuList.propTypes = {
    options: PropTypes.arrayOf(PropTypes.instanceOf(Sku)),
    handleSetSku: PropTypes.func,
    onOpenSaleModal: PropTypes.func
}